import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AssociateMarketingRoutes = defineRoute({
    record: {
        route: {
            path: "/associate-marketing",
            component: () => loadView(import("./AssociateMarketingTable.vue")),
        },
    },
    create: {
        route: {
            path: "/associate-marketing/create",
            component: () => loadView(import("./AssociateMarketingCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/associate-marketing/update/:id",
            component: () => loadView(import("./AssociateMarketingUpdate.vue")),
        },
        build(id: string) {
            return `/associate-marketing/update/${id}`;
        },
    },
});
